// @flow

import { gql } from "@apollo/client";
import { fragments as productionJobListItemFragments } from "../components/ProductionJobListItem/graph";

export default {
  productionJobs: gql`
    fragment ProductionJobList_productionJobs on OrderProductionJob {
      id
      ...ProductionJobListItem_productionJob
    }
    ${productionJobListItemFragments.productionJob}
  `
};
